<template>
      <div>
       <el-form ref="editForm" :model="editForm" label-width="120px">
            <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="發行單位:">
                    <el-radio-group v-model.number="editForm.type" @change="checkInput">
                        <el-radio :label="1">公司</el-radio>
                        <el-radio :label="2">通路商</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="品牌:">
                    <el-radio-group v-model.number="editForm.brand_id" @change="checkInput">
                        <el-radio :label="1">N牌</el-radio>
                        <el-radio :label="2">S牌</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="禮卷名稱:">
                    <el-input v-model="editForm.name" style="width: 50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="使用期限:">
                    <el-date-picker  v-model="date" type="daterange" range-separator="到" start-placeholde="開始日期" end-placeholde="結束日期"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
         <el-row>
            <el-col :lg="10" :offset="2" v-if="isType">
                <el-form-item label="會員:">
                    <el-tag  color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level0}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10" v-if="isType">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="editForm.memberdiscount_0" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="會員:">
                    <el-tag  color="#f9c6ba" effect="dark" style="color:red; border-color:red;">{{this.level1}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="editForm.memberdiscount_1" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-form-item label="會員:">
                    <el-tag  color="#f9c6ba" effect="dark" style="color:#494ca2;border-color:#f9c6ba;font-wi">{{this.level2}}</el-tag>
                </el-form-item>
            </el-col>
            <el-col :lg="10">
                <el-form-item label="折扣金:">
                    <el-input v-model.number="editForm.memberdiscount_2" style="width:50%;"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :lg="10" :offset="2">
                <el-button type="primary" @click="updateCoupon">修改禮卷</el-button>
                <el-button type="default" @click="back">返回</el-button>
            </el-col>
            <el-col :lg="10"></el-col>
        </el-row>
       </el-form>
      </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
    export default {
        name: 'Edit',
        props: {
            couponKey: String
        },
        data() {
            return {
                editForm: {
                        brand_id: null,
                    name: '',
                    type: null,
                    on_sale_start: '',
                    on_sale_end: '',
                    memberdiscount_1: null,
                    memberdiscount_2: null,
                    memberdiscount_0: null,
                     
                },
                date: [],
                isType: false, 
                level1: '',
                level2: '',  
            }
        },
        computed: mapGetters(["getCouponDetail"]),
        methods: {
            ...mapActions(["fetchCouponDetail", "updateCoupon"]),
                async fetchDetail(){
                const data = {_key: this.couponKey}
                await this.$store.dispatch('fetchCouponDetail', data)
                this.editForm = this.getCouponDetail
                console.log(this.editForm)
                this.checkInput(this.editForm.brand_id)
                this.checkType(this.editForm.type)
               this.date.push(
                   this.editForm.on_sale_start,
                   this.editForm.on_sale_end
               ) 
               
              
            },
               async updateCoupon(){
               this.strStartDate = moment(this.date[0]).format("YYYY-MM-DD")
               this.strEndDate = moment(this.date[1]).format("YYYY-MM-DD")
               const data = {
                   _key: this.editForm._key,
                   brand_id: this.editForm.brand_id,
                   name: this.editForm.name,
                   type: this.editForm.type,
                   on_sale_start: this.strStartDate,
                   on_sale_end: this.strEndDate,
                   memberdiscount_0: this.editForm.memberdiscount_0,
                   memberdiscount_1: this.editForm.memberdiscount_1,
                   memberdiscount_2: this.editForm.memberdiscount_2,
                  
               }
               await this.$store.dispatch('updateCoupon', data)
               if (this.getCouponError == true) {
                   this.$notify({
                       title: '失敗',
                       message: this.getCouponMsg,
                       type: 'error',
                       duration: '4500',
                       position: 'top-right'
                   });
                    }else {
                        this.$emit('back')
                        this.$notify({
                            title: '成功',
                            message: '修改禮卷成功',
                            type: 'success',
                            duration: '4500',
                            position: 'top-right'
                        });
                        
                    }
           },
            checkInput(brandId){
               if(brandId == 1){
                  
                   this.level1 = '白金'
                   this.level2 = '尊爵'
               }else if(brandId == 2){
                   this.level1 = '芙蓉'
                   this.level2 = '金鑽'
               }
           },
             checkType(type){
               if (type == 2) {
                    this.level0 = '非會員'
                    this.isType = true
               }else {
                   this.level10 = '',
                   this.isType = false
               }
           },
           back(){
               this.$emit('back')
           }
        },
        created() {
            this.fetchDetail()
           
        },
    }
</script>

<style lang="less" scoped>
    
</style>